import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';
import SnoozeBiz, { SnoozeType } from '../../biz/SnoozeBiz';
import { Select, Tooltip } from '~/notify/settings/__modules__/component';
import { useToast } from '~/__modules__/toast';
import { useDialog } from '~/__modules__/dialog';

SnoozeNotification.propTypes = {
  onSnoozeChange: PropTypes.func.isRequired,
};

export function SnoozeNotification({ onSnoozeChange }) {
  const { t } = useTranslation();
  const toast = useToast();
  const dialog = useDialog();

  const Options = [
    { value: SnoozeType.OneHour, label: t('noti_main_mute_1hour') },
    { value: SnoozeType.TwoHour, label: t('noti_main_mute_2hour') },
    { value: SnoozeType.Util8AM, label: t('noti_main_mute_until8') },
    { value: SnoozeType.Forever, label: t('noti_main_mute_untilend') },
  ];

  const [snoozed, setSnoozeMode] = useState({ level: SnoozeType.Off });
  const [selectedValue, setSelectedValue] = useState();

  const getSnoozeOption = () => {
    SnoozeBiz.getSnoozeOption().then((option) => {
      if (option) {
        setSnoozeMode(option);
        const showPopUp =
          !SnoozeBiz.isSnoozingTime(option) || option.level === SnoozeType.Off;
        onSnoozeChange(showPopUp);
      }
    });
  };

  const onSelect = (value) => {
    switch (value) {
      case SnoozeType.OneHour:
        SnoozeBiz.setSnoozeForOneHour()
          .then(() => {
            toast(t('saved'));
            setSelectedValue(value);
            getSnoozeOption();
          })
          .catch(() => {
            dialog.alert((action) => ({
              title: <Trans i18nKey="error_unknown_title" />,
              description: <Trans i18nKey="error_unknown_description" />,
              [action()]: (close) => {
                close && close();
              },
            }));
          });
        break;
      case SnoozeType.TwoHour:
        SnoozeBiz.setSnoozeForTwoHour()
          .then(() => {
            toast(t('saved'));
            setSelectedValue(value);
            getSnoozeOption();
          })
          .catch(() => {
            dialog.alert((action) => ({
              title: <Trans i18nKey="error_unknown_title" />,
              description: <Trans i18nKey="error_unknown_description" />,
              [action()]: (close) => {
                close && close();
              },
            }));
          });
        break;
      case SnoozeType.Util8AM:
        SnoozeBiz.setSnoozeForUtil8am()
          .then(() => {
            toast(t('saved'));
            setSelectedValue(value);
            getSnoozeOption();
          })
          .catch(() => {
            dialog.alert((action) => ({
              title: <Trans i18nKey="error_unknown_title" />,
              description: <Trans i18nKey="error_unknown_description" />,
              [action()]: (close) => {
                close && close();
              },
            }));
          });
        break;
      case SnoozeType.Forever:
        SnoozeBiz.setSnoozeForever()
          .then(() => {
            toast(t('saved'));
            setSelectedValue(value);
            getSnoozeOption();
          })
          .catch(() => {
            dialog.alert((action) => ({
              title: <Trans i18nKey="error_unknown_title" />,
              description: <Trans i18nKey="error_unknown_description" />,
              [action()]: (close) => {
                close && close();
              },
            }));
          });
        break;
    }
  };

  const setSnoozeOff = () => {
    SnoozeBiz.setSnoozeOff()
      .then(() => {
        toast(t('saved'));
        setSelectedValue();
        getSnoozeOption();
      })
      .catch(() => {
        dialog.alert((action) => ({
          title: <Trans i18nKey="error_unknown_title" />,
          description: <Trans i18nKey="error_unknown_description" />,
          [action()]: (close) => {
            close && close();
          },
        }));
      });
  };

  useEffect(() => {
    getSnoozeOption();
  }, []);

  let snoozeTip =
    snoozed.level === SnoozeType.Forever
      ? t('noti_main_mute_untilend')
      : snoozed.level === SnoozeType.OneHour ||
        snoozed.level === SnoozeType.TwoHour ||
        snoozed.level === SnoozeType.Util8AM
      ? t('noti_main_mute_define', { time: snoozed.time })
      : '';

  return (
    <li className="item">
      <div className="title_area">
        <h4 className="title">
          <span className="text">{t('noti_main_mutenoti')}</span>
          <Tooltip>{t('noti_main_tooltip1')}</Tooltip>
          <span
            className="status ico_status_alarm"
            style={{
              display:
                SnoozeBiz.isSnoozingTime(snoozed) &&
                snoozed.level !== SnoozeType.Off
                  ? 'block'
                  : 'none',
            }}
          >
            {snoozeTip}
            <a
              href="#"
              onClick={() => {
                setSnoozeOff();
              }}
            >
              {t('noti_main_mute_stop')}
            </a>
          </span>
        </h4>
      </div>
      <div className="task_area">
        <Select
          placeholder={t('noti_main_seltime')}
          value={selectedValue}
          onChange={(e) => onSelect(e.target.value)}
          options={Options}
        >
          {Options.map((item) => {
            return (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            );
          })}
        </Select>
      </div>
    </li>
  );
}
